import { Construction } from 'lucide-react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@shigo-ui/ui';

import { dashboardT, type DashboardMessageKey } from '../lib/messages';
import { ShigoFeature } from './shigo-feature';

const featureMessageKeys: Record<
  ShigoFeature,
  { title: DashboardMessageKey; description: DashboardMessageKey }
> = {
  [ShigoFeature.Dashboard]: {
    title: 'nav.dashboard',
    description: 'placeholder.dashboard.description',
  },
  [ShigoFeature.Supply]: {
    title: 'nav.supply',
    description: 'placeholder.supply.description',
  },
  [ShigoFeature.Demand]: {
    title: 'nav.demand',
    description: 'placeholder.demand.description',
  },
  [ShigoFeature.Campaigns]: {
    title: 'nav.campaigns',
    description: 'placeholder.campaigns.description',
  },
  [ShigoFeature.Reporting]: {
    title: 'nav.reporting',
    description: 'placeholder.reporting.description',
  },
};

type FeaturePlaceholderPageProps = {
  feature: ShigoFeature;
  titleKey?: DashboardMessageKey;
  descriptionKey?: DashboardMessageKey;
};

export function FeaturePlaceholderPage({
  feature,
  titleKey,
  descriptionKey,
}: FeaturePlaceholderPageProps) {
  const messageKeys = featureMessageKeys[feature];

  return (
    <section className="flex min-h-[calc(100dvh-4rem)] items-center justify-center px-5 py-10 lg:min-h-[calc(100dvh-4rem)] lg:px-8">
      <Card className="w-full max-w-xl rounded-lg">
        <CardHeader>
          <div className="bg-primary/10 text-primary mb-2 flex h-10 w-10 items-center justify-center rounded-md">
            <Construction className="h-5 w-5" />
          </div>
          <CardTitle>{dashboardT(titleKey ?? messageKeys.title)}</CardTitle>
          <CardDescription className="max-w-md leading-6">
            {dashboardT(descriptionKey ?? messageKeys.description)}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <span className="border-border bg-muted text-muted-foreground inline-flex rounded-md border px-2.5 py-1 text-xs font-medium">
            {dashboardT('placeholder.comingSoon')}
          </span>
        </CardContent>
      </Card>
    </section>
  );
}
